import ApiClient, {requestRemoteData} from '../../API/api';

const ORDER_ENDPOINT = 'account/orders';

/**
 * @param unsafeOrder
 * @returns {Order}
 */
const parseOrder = (unsafeOrder)=> {
  if (!('id' in unsafeOrder)) {
    throw new Error('Invalid Order.');
  }
  if (!('code' in unsafeOrder)) {
    throw new Error('Invalid Order.');
  }
  return unsafeOrder;
};

// TODO: use remote data
/**
 * @param {number} addressId
 * @param {string} userComment
 * @returns {Promise<Order>}
 */
export const placeOrder = (addressId, userComment) => {
  return ApiClient.performRequest(
    ORDER_ENDPOINT,
    { method: 'POST', body: { addressId, userComment } }
  ).then(parseOrder);
};

export const placeOrderBis = (userComment, addressId = null) => {
    return requestRemoteData(
        'orders',
        {
            method: 'POST',
            body: { userComment, ...(addressId != null && { addressId }) },
        }
    );
}

// TODO: use remote data
/**
 * En modo comercial suplantando, la cabecera hace que el historial sea el del cliente
 * que se esta mirando (pedidos web suyos + los de cualquier comercial en su nombre).
 * @param {string|null} actingAsNumCliente
 * @returns {Promise<Order[]>}
 */
export const getAll = (actingAsNumCliente = null) => {
  const headers = {};
  if (actingAsNumCliente) headers['X-Acting-As-Client'] = actingAsNumCliente;
  return ApiClient.performRequest(ORDER_ENDPOINT, { headers });
};

export const reconcileCart = () => {
  return requestRemoteData('orders/cart/reconcile');
};
